import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RefreshPeriodService {

  private refreshSubject = new Subject<any>();

  refresh$ = this.refreshSubject.asObservable();

  private refreshSubject2 = new Subject<any>();

  refresh2$ = this.refreshSubject2.asObservable();

  emitRefresh(selectedIds: any): void {
    this.refreshSubject.next(selectedIds);
  }

  emitRefresh2(selectedIds: any): void {
    this.refreshSubject2.next(selectedIds);
  }
}
